/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x1abbcc){return _0x1abbcc&&_0x1abbcc['__esModule']?_0x1abbcc:{'default':_0x1abbcc};};Object['defineProperty'](exports,'__esModule',{'value':!0x0}),exports['_SERVICE']=void 0x0;const sessioncollection_1=__importDefault(require('./sessioncollection'));exports['_SERVICE']=0x3,exports['default']=class{static async['getConnectedSessions'](_0x1d3a23,_0x3c379e,_0x4bc6b3){const _0x2e3a5b=new sessioncollection_1['default'](_0x3c379e,_0x4bc6b3);return await _0x2e3a5b['connect'](_0x1d3a23),_0x2e3a5b;}};